import { ActionReducerMap } from '@ngrx/store';
import { permissionReducer } from './permission/permission.reducers';
import { PermissionMenusState } from './permission/permission.state';
import { paginationReducer } from './pagination/pagination.reducer';
import { PaginationState } from './pagination/pagination.state';
import { authReducer } from './auth/auth.reducer';
import { AuthState } from './auth/auth.state';


export interface AppState {
  permission: PermissionMenusState;
  pagination: PaginationState;
  auth: AuthState;
}

export const reducers: ActionReducerMap<AppState> = {
  permission: permissionReducer,
  pagination: paginationReducer,
  auth: authReducer,
};
